import { createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "cancellation-dates-manager" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-wrap gap-3 mb-2"
}
const _hoisted_3 = { class: "form-check" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_8 = { class: "d-flex align-items-center mb-2" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = {
  class: "bg-light rounded p-2",
  style: {"max-height":"400px","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_11 = { class: "d-flex align-items-center py-1" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = ["id", "checked", "disabled", "onChange"]
const _hoisted_14 = ["for"]
const _hoisted_15 = {
  key: 1,
  class: "ms-auto badge bg-danger"
}
const _hoisted_16 = {
  key: 0,
  class: "alert alert-danger"
}

import { computed, onMounted, ref, watch } from "vue";
import { RRule } from "rrule";


export default {
  __name: 'CancellationDatesManager',
  props: {
	form: {
		type: Object,
		required: true,
	},
	rrulePattern: {
		type: String,
		default: "",
	},
	startDate: {
		type: String,
		default: "",
	},
	startTime: {
		type: String,
		default: "",
	},
	error: {
		type: String,
		default: "",
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	// Map "Y-m-d" => { type: "holiday"|"lectureBreak"|"semesterHoliday", label }. When non-empty and
	// enableExclusions is set, occurrences are badged and Vorlesungspause/Feiertage can be auto-excluded.
	nonTeachingDates: {
		type: Object,
		default: () => ({}),
	},
	enableExclusions: {
		type: Boolean,
		default: false,
	},
	exclusionsDefaultOn: {
		type: Boolean,
		default: false,
	},
},
  setup(__props) {

const props = __props;

// Extract form for template
const { form } = props;

// Generate series dates from RRule pattern - computed for reactivity
const generateSeriesDates = computed(() => {
	if (!props.rrulePattern || !props.startDate || !props.startTime) return [];

	try {
		// Parse the RRule pattern (remove RRULE: prefix if present)
		const cleanPattern = props.rrulePattern.replace(/^RRULE:/, "");
		const rruleOptions = {};

		// Parse pattern manually
		cleanPattern.split(";").forEach((part) => {
			const [key, value] = part.split("=");
			if (key === "FREQ") {
				rruleOptions.freq = RRule[value];
			} else if (key === "COUNT") {
				const count = parseInt(value);
				// Ensure count is valid (at least 1)
				rruleOptions.count = count && count >= 1 ? count : 1;
			} else if (key === "INTERVAL") {
				rruleOptions.interval = parseInt(value);
			} else if (key === "BYDAY") {
				rruleOptions.byweekday = value.split(",").map((day) => RRule[day]);
			} else if (key === "BYMONTHDAY") {
				rruleOptions.bymonthday = value.split(",").map((d) => parseInt(d));
			}
		});

		// Set start date
		const startDateTime = new Date(`${props.startDate}T${props.startTime}`);
		rruleOptions.dtstart = startDateTime;

		const rrule = new RRule(rruleOptions);
		return rrule.all();
	} catch (error) {
		console.warn("Error generating series preview:", error);
		return [];
	}
});

// Get series preview with cancelled dates - function using computed generateSeriesDates
function getSeriesPreview(cancelledDates = []) {
	const dates = generateSeriesDates.value;
	return dates.map((date) => {
		const dateString = date.toISOString().split("T")[0];
		return {
			date: dateString,
			isCancelled: cancelledDates.includes(dateString),
		};
	});
}

const getTotalDatesCount = computed(() => {
	return generateSeriesDates.value.length;
});

function getEffectiveDatesCount(cancelledDates = []) {
	return getSeriesPreview(cancelledDates).filter((date) => !date.isCancelled).length;
}

// Methods
function formatDate(dateString) {
	try {
		const date = new Date(dateString + "T00:00:00");
		return date.toLocaleDateString("de-DE", {
			weekday: "short",
			year: "numeric",
			month: "short",
			day: "numeric",
		});
	} catch (error) {
		return dateString;
	}
}

function toggleDate(field, dateString) {
	if (props.disabled) return;

	const current = field.state.value || [];
	const isCurrentlyCancelled = current.includes(dateString);

	let updated;
	if (isCurrentlyCancelled) {
		// Remove from cancellations (include the date)
		updated = current.filter((date) => date !== dateString);
	} else {
		// Add to cancellations (exclude the date)
		updated = [...current, dateString];
	}

	field.handleChange(updated);
}

// --- Non-teaching dates (Vorlesungspause / Feiertage / vorlesungsfrei) ---

const NT_BADGE_CLASS = {
	holiday: "bg-danger",
	lectureBreak: "bg-warning text-dark",
	semesterHoliday: "bg-secondary",
};

function markerFor(dateString) {
	return props.nonTeachingDates?.[dateString] || null;
}

function markerClass(dateString) {
	const marker = markerFor(dateString);
	return marker ? NT_BADGE_CLASS[marker.type] || "bg-secondary" : "";
}

// Default the two ignore checkboxes (Vorlesungspause / Feiertage). On = auto-exclude.
const ignoreLectureBreak = ref(props.exclusionsDefaultOn);
const ignoreHolidays = ref(props.exclusionsDefaultOn);

// Re-seed defaults when the mode changes (e.g. create vs. edit-series reuse the component).
watch(
	() => props.exclusionsDefaultOn,
	(value) => {
		ignoreLectureBreak.value = value;
		ignoreHolidays.value = value;
	}
);

// Generated occurrence dates ("Y-m-d") whose classification matches the given type.
function categoryDates(type) {
	return generateSeriesDates.value
		.map((date) => date.toISOString().split("T")[0])
		.filter((dateString) => props.nonTeachingDates?.[dateString]?.type === type);
}

function getCancelled() {
	return props.form.getFieldValue("cancelledDates") || [];
}

function addDates(dates) {
	if (dates.length === 0) return;
	const current = new Set(getCancelled());
	const before = current.size;
	dates.forEach((date) => current.add(date));
	if (current.size !== before) {
		props.form.setFieldValue("cancelledDates", [...current]);
	}
}

function removeDates(dates) {
	if (dates.length === 0) return;
	const remove = new Set(dates);
	const updated = getCancelled().filter((date) => !remove.has(date));
	props.form.setFieldValue("cancelledDates", updated);
}

watch(ignoreHolidays, (value) => {
	if (!props.enableExclusions) return;
	value ? addDates(categoryDates("holiday")) : removeDates(categoryDates("holiday"));
});

watch(ignoreLectureBreak, (value) => {
	if (!props.enableExclusions) return;
	value ? addDates(categoryDates("lectureBreak")) : removeDates(categoryDates("lectureBreak"));
});

// Pre-mark the enabled categories (Vorlesungspause / Feiertage) as cancelled. Runs after render
// (flush: "post" / onMounted) so it never writes to the form during the preview's render cycle.
function applyEnabledExclusions() {
	if (!props.enableExclusions) return;
	if (ignoreHolidays.value) addDates(categoryDates("holiday"));
	if (ignoreLectureBreak.value) addDates(categoryDates("lectureBreak"));
}

watch(generateSeriesDates, applyEnabledExclusions, { flush: "post" });
onMounted(applyEnabledExclusions);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Ignore Vorlesungspause / Feiertage during series generation (before the preview) "),
    (__props.enableExclusions && __props.rrulePattern)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              id: "ignoreLectureBreak",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((ignoreLectureBreak).value = $event)),
              type: "checkbox",
              class: "form-check-input",
              disabled: __props.disabled
            }, null, 8 /* PROPS */, _hoisted_4), [
              [_vModelCheckbox, ignoreLectureBreak.value]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              class: "form-check-label",
              for: "ignoreLectureBreak"
            }, " Vorlesungspause ignorieren? ", -1 /* CACHED */))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              id: "ignoreHolidays",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((ignoreHolidays).value = $event)),
              type: "checkbox",
              class: "form-check-input",
              disabled: __props.disabled
            }, null, 8 /* PROPS */, _hoisted_6), [
              [_vModelCheckbox, ignoreHolidays.value]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              class: "form-check-label",
              for: "ignoreHolidays"
            }, " Feiertage ignorieren? ", -1 /* CACHED */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_unref(form).Field, { name: "cancelledDates" }, {
      default: _withCtx(({ field }) => [
        _createVNode(_unref(form).Subscribe, null, {
          default: _withCtx(({ values }) => [
            _createCommentVNode(" Series Dates List "),
            _createElementVNode("div", null, [
              (__props.rrulePattern && getSeriesPreview(values.cancelledDates || []).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-calendar-check text-primary me-2" }, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_9, " Termine der Serie (" + _toDisplayString(getEffectiveDatesCount(values.cancelledDates || [])) + " von " + _toDisplayString(getTotalDatesCount.value) + " Terminen aktiv): ", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSeriesPreview(values.cancelledDates || []), (date) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: date.date,
                            class: "mb-1"
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("input", {
                                  id: `date-${date.date}`,
                                  type: "checkbox",
                                  class: "form-check-input",
                                  checked: !date.isCancelled,
                                  disabled: __props.disabled,
                                  onChange: $event => (toggleDate(field, date.date))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13),
                                _createElementVNode("label", {
                                  for: `date-${date.date}`,
                                  class: _normalizeClass(["form-check-label", {
                              'text-decoration-line-through text-muted':
                                date.isCancelled,
                              'text-dark': !date.isCancelled,
                            }])
                                }, _toDisplayString(formatDate(date.date)), 11 /* TEXT, CLASS, PROPS */, _hoisted_14)
                              ]),
                              (markerFor(date.date))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["ms-2 badge", markerClass(date.date)])
                                  }, _toDisplayString(markerFor(date.date).label), 3 /* TEXT, CLASS */))
                                : _createCommentVNode("v-if", true),
                              (date.isCancelled)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Ausfall"))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]))
                : (!__props.rrulePattern)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" No preview message "),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-muted text-center py-3" }, [
                        _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                        _createTextVNode(" Wählen Sie zuerst ein Wiederholungsmuster aus, um die Termine zu sehen. ")
                      ], -1 /* CACHED */))
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Error Display "),
            (__props.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
                  _createTextVNode(" " + _toDisplayString(__props.error), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

}